// extracted by mini-css-extract-plugin
module.exports = {"container":"Program_container__2xmp4","wrapper":"Program_wrapper__2QhR2","infolog1--text":"Program_infolog1--text__3o_se","section":"Program_section__sDFzr"};